import type { IRadioButton } from '@/components/RadioButtonController/RadioButton/RadioButton.types'

export const useHasProduct = () => {
  const { t } = useI18n()
  const hasProducts = ref<IRadioButton[]>([
    {
      id: 'has-product-0',
      label: t('form.no'),
      value: false,
    },
    {
      id: 'has-product-1',
      label: t('form.yes'),
      value: true,
    },
  ])

  return {
    hasProducts,
  }
}
